import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '@/lib/analytics';

/* Mounted once inside the router: boots GA4 and reports every SPA route change. */
export function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => { initAnalytics(); }, []);

  useEffect(() => {
    const id = setTimeout(() => trackPageView(pathname + search), 150);
    return () => clearTimeout(id);
  }, [pathname, search]);

  return null;
}
